export default __webpack_public_path__ + "static/media/cine-suntem-noi.494a9833.svg";